import { Helmet } from "react-helmet-async";

const SITE_URL = "https://transferavellino.com";
const SITE_NAME = "Transfer Avellino";
const DEFAULT_IMAGE = "https://customer-assets.emergentagent.com/job_luxury-ride-avellino/artifacts/b7diefut_ncc-avellino.png";
const LOCALE = "it_IT";

export default function SEOHead({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  noindex = false,
}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Noleggio Con Conducente Premium - NCC Avellino`;
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      {/* Primary */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Language */}
      <html lang="it" />
      <meta httpEquiv="content-language" content="it" />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content={LOCALE} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Geo */}
      <meta name="geo.region" content="IT-AV" />
      <meta name="geo.placename" content="Avellino" />
      <meta name="geo.position" content="40.9146076;14.7715835" />
      <meta name="ICBM" content="40.9146076, 14.7715835" />

      {/* Additional SEO */}
      <meta name="author" content="Transfer Avellino" />
      <meta name="theme-color" content="#0A0A0A" />
      <meta name="format-detection" content="telephone=yes" />
    </Helmet>
  );
}
